<template>
    <div>
        <!-- <v-row v-if="data && Object.keys(data).length > 0">
            <v-col cols="12">
                <v-card-title>
                    <span class="headline"><b>{{$t("ExtractedDataComponent.extracted_information")}}</b></span>
                </v-card-title>
            </v-col>
        </v-row> -->

        <v-row v-if="data && Object.keys(data).length > 0">
            <v-col cols="12">
                <v-row v-for="keyInfo in orderedKeys" :key="keyInfo.key">
                    <!-- Section Title with optional info button -->
                    <v-col cols="12" v-if="keyInfo.section_title">
                        <v-row align="center" class="ma-0">
                            <v-col cols="1"></v-col>
                            <v-col cols="10" class="pa-0">
                                <div class="d-flex align-center">
                                    <h3 class="section-title">{{ keyInfo.section_title }}</h3>
                                    <v-tooltip bottom v-if="keyInfo.description">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                x-small
                                                class="ml-2"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="showDescriptionDialog(keyInfo)"
                                            >
                                                <v-icon small color="primary">mdi-information</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ver descripción</span>
                                    </v-tooltip>
                                </div>
                            </v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                    </v-col>

                    <!-- Data content -->
                    <template v-if="!Array.isArray(data[keyInfo.key])">
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                            <EntityInstanceUI :entity_instance_id="data[keyInfo.key]" :intern_key="keyInfo.key"></EntityInstanceUI>
                        </v-col>
                        <v-col cols="1"></v-col>
                    </template>
                    <template v-else>
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                            <ListOfInstancesEditor :entity_instances_ids="data[keyInfo.key]" :intern_key="keyInfo.key"></ListOfInstancesEditor>
                        </v-col>
                        <v-col cols="1"></v-col>
                    </template>
                </v-row>
            </v-col>
        </v-row>

        <!-- Description Dialog -->
        <v-dialog v-model="descriptionDialog" max-width="500px">
            <v-card v-if="selectedKeyInfo">
                <v-card-title class="headline">
                    {{ selectedKeyInfo.section_title }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p style="white-space: pre-wrap;">{{ selectedKeyInfo.description }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="descriptionDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
import DocTextField from '@/components/DocTextField.vue';
import EntityInstanceUI from '@/modules/entities/infra/EntityInstanceUI.vue'
import ListOfInstancesEditor from '@/modules/entities/infra/ListOfInstancesEditor.vue'

export default {
    name: "ExtractedDataComponent",
    components: {
        DocTextField,
        EntityInstanceUI,
        ListOfInstancesEditor
    },
    data() {
        return {
            descriptionDialog: false,
            selectedKeyInfo: null
        }
    },
    props: {
        data:{
            type: [Object],
            required: true,
            default: null
        },
        title:{
            type: String,
            required: false,
            default: ''
        },
        keyOrder:{
            type: Array,
            required: false,
            default: null
        }
    },
    computed: {
        orderedKeys() {
            if (!this.data) return [];

            const dataKeys = Object.keys(this.data);

            // If no keyOrder is provided, return keys in original order (backward compatibility)
            if (!this.keyOrder || this.keyOrder.length === 0) {
                return dataKeys.map(key => ({ key, section_title: '', description: '', nickname: '' }));
            }

            // Check if keyOrder contains metadata objects or just strings (backward compatibility)
            const isMetadataFormat = this.keyOrder.length > 0 && typeof this.keyOrder[0] === 'object' && this.keyOrder[0].key;

            if (isMetadataFormat) {
                // New format: array of objects with metadata
                const orderedExistingKeys = this.keyOrder.filter(keyInfo => dataKeys.includes(keyInfo.key));

                // Find keys in data that are not in keyOrder (these go at the end)
                const orderedKeys = orderedExistingKeys.map(ki => ki.key);
                const unorderedKeys = dataKeys.filter(key => !orderedKeys.includes(key))
                    .map(key => ({ key, section_title: '', description: '', nickname: '' }));

                return [...orderedExistingKeys, ...unorderedKeys];
            } else {
                // Old format: array of strings (backward compatibility)
                const orderedExistingKeys = this.keyOrder.filter(key => dataKeys.includes(key))
                    .map(key => ({ key, section_title: '', description: '', nickname: '' }));

                const unorderedKeys = dataKeys.filter(key => !this.keyOrder.includes(key))
                    .map(key => ({ key, section_title: '', description: '', nickname: '' }));

                return [...orderedExistingKeys, ...unorderedKeys];
            }
        }
    },
    methods: {
        showDescriptionDialog(keyInfo) {
            this.selectedKeyInfo = keyInfo;
            this.descriptionDialog = true;
        }
    }

};
</script>

<style scoped>
.section-title {
    color: var(--v-primary-base);
    font-weight: 600;
    margin-top: 12px;
    margin-bottom: 8px;
}

.primary-background {
    background-color: var(--v-primary-base);
}
.primary-border {
    border-color: var(--v-primary-base) !important;
}
</style>
<style>
/* .toolbar > .v-toolbar__content {
    justify-content: space-around;
} */

.stepper.v-stepper--vertical {
    padding: 0px ;
} 

.stepper.v-stepper {
    box-shadow: none;
}
</style>